



































import { Component, Mixins, Prop } from "vue-property-decorator";
import { ReceptionPatient } from "../../../../domain/workflow/reception";
import { Patient } from "../../../../domain/patient";
import { PatientViewerMixin } from "../../../patient/viewers/mixins";

@Component({
  components: {}
})
export default class ReceptionPatientView extends Mixins(PatientViewerMixin) {
  @Prop()
  patientInfo: ReceptionPatient;

  get patient(): Patient {
    return this.patientInfo ? this.patientInfo.patient : null;
  }

  get birthAge(): string {
    return this.formatBirthdayString((b, a) => b + "(" + a + ")");
  }
}
